import { WindowHelper } from '@shared/helpers/window.helper';
import { ComponentType } from '@angular/cdk/portal';
import { MailingSidenavComponent } from '@modules/mailing-templates/shared/modules/mailing-sidenav/components/mailing-sidenav/mailing-sidenav.component';
import { Project } from '@modules/projects/shared/models/project.model';
import { TaskType } from '@shared/enums/task-type.enum';
import { TaskViewState } from '@shared/enums/task-view-state.enum';
import { Task } from '@shared/models/task.model';
import { TaskSidenavComponent } from '../components/task-sidenav/task-sidenav.component';
import { BaseTaskSidenavController } from './base-task-sidenav.controller';
import { TaskSidenavController } from './task-sidenav.controller';

export class ChangesSidenavController extends BaseTaskSidenavController {
  static readonly component: ComponentType<TaskSidenavComponent> = TaskSidenavComponent;
  readonly changesMailingIdNumber = 25;

  constructor() {
    super();
  }

  addChange(projectID?: number) {
    this.sidenav.open(
      ChangesSidenavController.component,
      this.getSidenavConfig({ type: TaskType.TYPE_CHANGE }),
      {
        viewState: TaskViewState.CREATE,
        replaceUrl: true,
        projectID
      }
    );
  }

  editChange(projectID?: number, taskId?: string) {
    this.sidenav.open(
      ChangesSidenavController.component,
      this.getSidenavConfig({ type: TaskType.TYPE_CHANGE }),
      {
        viewState: TaskViewState.EDIT,
        replaceUrl: true,
        projectID,
        taskId
      }
    );
  }

  previewChange(taskId: string) {
    this.sidenav.open(
      ChangesSidenavController.component,
      this.getSidenavConfig({ type: TaskType.TYPE_CHANGE }),
      {
        viewState: TaskViewState.PREVIEW,
        replaceUrl: true,
        taskId
      }
    );
  }

  taskCreate(connectedTaskId: number, projectId?: number) {
    const ctrl = new TaskSidenavController();
    ctrl.addTask({ projectID: projectId, connectedTaskId });
  }

  createMailing(id: number, _params: any) {
    const config: any = {
      maxWidth: '709px',
      class: 'no-padding',
      hideBackdrop: WindowHelper.isMoreLessMD,
      hardReload: true,
      closeOnBackdrop: true
    };

    const params = Object.assign({ templateId: id }, _params);
    this.sidenav.open(MailingSidenavComponent, config, params);
  }

  shareSingleChange(task: Task, projectId: number, project?: Project) {
    this.createMailing(this.changesMailingIdNumber, {
      projectId: projectId,
      email: null,
      taskIds: [task?.id]
    });
  }

  shareMultipleChanges(taskIds: number[], projectId: number, project?: Project) {
    this.createMailing(this.changesMailingIdNumber, { projectId: projectId, email: null, taskIds });
  }

  taskCreateFromChanges(selectedChanges: Task[], projectId: number): void {
    const ctrl = new TaskSidenavController();
    ctrl.addTask({ projectID: projectId, selectedChanges });
  }
}
